<template lang="html">
  <v-tabs
    v-if="mapaCamposDinamicos && mapaCamposDinamicos.length"
    centered
    v-model="tabSelecionada"
    color="accent"
    background-color="rgba(0,0,0,0)"
    class="NivelCliente__tabs">
    <v-tab
      v-for="(item, index) in mapaCamposDinamicos"
      :href="`#tab-${item.label}`"
      :key="`nivel-cliente-tab-${index}`">
      {{ item.entidadeEstrangeira }}
    </v-tab>

    <v-tabs-items v-model="tabSelecionada">
      <v-tab-item
        v-for="(item, index) in mapaCamposDinamicos"
        :id="`tab-${item.label}`"
        :somenteLeitura="somenteLeitura"
        :key="`nivel-cliente-tab-item-${index}`">
        <component
          :is="item.indRecursiva ? 'TabelaGenericaRecursiva' : 'TabelaGenerica'"
          :item="item"
          :idNivelExtensao="item.idNivelExtensao"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from 'vuex';
import { generateComputed } from '../../common/functions/roles-computed-generator';
import TabelaGenerica from './abas/TabelaGenerica';
import TabelaGenericaRecursiva from './abas/TabelaGenericaRecursiva';

export default {
  name: 'NivelCliente',
  data() {
    return {
      tabSelecionada: null,
      resourceMetadado: this.$api.metadado(this.$resource),
    };
  },
  computed: {
    ...generateComputed('nivel cliente', [
      'canEdit',
      'canGet',
      'canAccessPage',
    ]),
    somenteLeitura() {
      return !this.canEdit && this.canGet;
    },
    ...mapGetters('metadados', [
      'getClienteMetadado',
    ]),
    mapaCamposDinamicos() {
      if (this.getClienteMetadado && this.getClienteMetadado.mapaEntidades) {
        const array = Object.keys(this.getClienteMetadado.mapaEntidades).filter((el) => {
          if (this.getClienteMetadado.mapaEntidades[el].dependentes
            && this.getClienteMetadado.mapaEntidades[el].dependentes.includes('CLIENTE')) {
            return true;
          }
          return false;
        });
        return array
          .map((el) => this.getClienteMetadado.mapaEntidades[el])
          .sort((el) => !el.indRecursiva);
      }
      return [];
    },
    metadadosCliente() {
      if (this.getClienteMetadado && this.getClienteMetadado.mapaEntidades) {
        return this.getClienteMetadado;
      }
      return undefined;
    },
  },
  components: {
    TabelaGenericaRecursiva,
    TabelaGenerica,
  },
  methods: {
    ...mapActions('metadados', [
      'setClienteMetadado',
    ]),
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast('Acesso negado');
      }
    },
    requestPopularHeader() {
      if (this.getClienteMetadado) {
        return;
      }
      this.setClienteMetadado({
        resource: this.resourceMetadado.listarCliente,
      });
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
    this.requestPopularHeader();
  },
};
</script>
<style lang="css">
.NivelCliente__tabs a.v-tab {
  color: var(--v-accent) !important;
}
.NivelCliente__tabs .v-tabs-items {
  background: none;
}
</style>
